<template>
  <div class="max-w-360 m-auto w-full flex justify-center">
    <div class="flex flex-col gap-2 p-4 w-207 rounded-8xl glass-frosted">
      <Updator />

      <DongleUpdator v-if="hasDongleUpdator" />

      <WirelessSleepTime v-if="hasWirelessSleepTime" />

      <USBReportRate v-if="hasUsbReportRate" />

      <ProductDisplay />

      <FactoryReset />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useDeviceStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  import Updator from './components/Updator.vue'
  import DongleUpdator from './components/DongleUpdator.vue'
  import WirelessSleepTime from './components/WirelessSleepTime.vue'
  import USBReportRate from './components/USBReportRate.vue'
  import ProductDisplay from '@/components/settings/ProductDisplay.vue'
  import FactoryReset from '@/components/settings/FactoryReset.vue'
  import { ConnectionType, KeyboardPerfCapability } from '@rapoo/device-sdk'

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const hasKeyboardPerf = computed(() => {
    return (
      currentDevice.value?.manifest.capabilities?.find((c) => c.type === 'keyboardPerf') ?? null
    )
  })

  const hasUsbReportRate = computed(() => {
    return (
      hasKeyboardPerf.value &&
      (hasKeyboardPerf.value as KeyboardPerfCapability).config.reportRateOptions
    )
  })

  const hasWirelessSleepTime = computed(() => {
    return (
      hasKeyboardPerf.value &&
      (hasKeyboardPerf.value as KeyboardPerfCapability).config.sleepTimeRange
    )
  })

  // 接收器卡仅服务于已通过 Telink 接收器连接的键盘，纯有线和有线直连时均不显示。
  const hasDongleUpdator = computed(() => {
    const device = currentDevice.value
    return (
      device?.manifest.driver === 'TelinkKeyboard' &&
      Boolean(device.manifest.dongleModel) &&
      device.getConnectionType() === ConnectionType.Wireless
    )
  })
</script>

<style lang="scss" scoped></style>
